import { Injectable } from '@angular/core';
import * as jwtDecode from 'jwt-decode';

const APP_PREFIX = 'SABEMI';

@Injectable({
  providedIn: 'root',
})
export class AuthTokenService {
  public LOCAL_STORAGE_USER_JWT_TOKEN_KEY =
    APP_PREFIX + '_' + 'CURRENT_USER_ACCESS_TOKEN';
  public LOCAL_STORAGE_USER_JWT_REFRESH_TOKEN_KEY =
    APP_PREFIX + '_' + 'CURRENT_USER_ACCESS_REFRESH_TOKEN';
  public LOCAL_STORAGE_ACCESS_TOKEN = APP_PREFIX + '_' + 'ACCESS_TOKEN';

  public setAccessTokens(normalAccessToken: string, refreshToken: string): void {
    localStorage.setItem(this.LOCAL_STORAGE_USER_JWT_TOKEN_KEY, normalAccessToken);
    localStorage.setItem(this.LOCAL_STORAGE_USER_JWT_REFRESH_TOKEN_KEY, refreshToken);
  }

  public getToken(tokenKey = this.LOCAL_STORAGE_USER_JWT_TOKEN_KEY): string {
    return localStorage.getItem(tokenKey);
  }

  public decodeAccessToken(): any {
    try {
      return jwtDecode(this.getToken(this.LOCAL_STORAGE_USER_JWT_TOKEN_KEY));
    } catch (err) {
      return null;
    }
  }

  public deleteAccessTokens(): void {
    localStorage.removeItem(this.LOCAL_STORAGE_USER_JWT_TOKEN_KEY);
    localStorage.removeItem(this.LOCAL_STORAGE_USER_JWT_REFRESH_TOKEN_KEY);
    localStorage.removeItem('isAssistedMode');
  }
}
